export const DummyImmoImages = ["/images/placeholder.jpg"];

export const DummyDetailImages = [
	"/stock_images/1.jpg",
	"/stock_images/2.jpg",
	"/stock_images/3.jpg",
	"/stock_images/4.jpg",
	"/stock_images/5.jpg",
	"/stock_images/6.jpg"
];

export const NoImageAvailablePlaceholder = "/images/placeholder.jpg";
export const LeonCompanyImages = [
	"/images/leon-company-1.png",
	"/images/leon-company-2.png"
];
export const LeonCompanyMain = LeonCompanyImages[0];

export const HeaderImages = [
	"/images/startseite-header.jpg"
];

export const HeaderVermietung = "/images/vermietung_header2.jpg";

export const PeopleImages = {
	FidelGarten: "/images/fidel_garten.png",
	FidelPool: "/images/fidel_pool.png",
	Andrea: "/images/andrea.png"
};

export const getRandomHeaderImage = () => {
	return HeaderImages[Math.floor(Math.random() * HeaderImages.length)];
};

export const MietenSie = "/images/mieten_sie.png";
